import ia from '../../assets/img/login-banners/01.jpg';
import iaProntuario from '../../assets/img/login-banners/02.png';

export const loginBannersFullSize = [
  {
    src: iaProntuario,
    alt: 'Propaganda da IA no prontuário.',
    isClickable: true,
    redirectURL: 'https://wa.me/554491832589?text=Olá!%20Sou%20cliente%20e%20tenho%20interesse%20em%20saber%20mais%20sobre%20a%20IA%20no%20prontuário'
  },
  {
    src: ia,
    alt: 'Propaganda IA.',
    isClickable: true,
    redirectURL: 'https://wa.me/554491832589?text=Olá!%20Sou%20cliente%20e%20tenho%20interesse%20em%20saber%20mais%20sobre%20a%20IA%20App%20Health'
  },
];
